import React, { Component } from "react";

import "./Accordion.component.scss";

export interface AccordionProps {
    title: any;
}

export interface AccordionState {
    open: boolean;
}

export default class Accordion extends Component<
    AccordionProps,
    AccordionState
> {
    constructor(props: AccordionProps) {
        super(props);

        this.state = {
            open: false
        };
    }

    toogleAccordion = () => {
        this.setState({
            open: !this.state.open
        });
    };

    render() {
        return (
            <div
                className={`accordion-container ${
                    this.state.open ? "open" : ""
                }`}
            >
                <div className="inner-card">
                    <div
                        className="inner-card-title"
                        onClick={this.toogleAccordion}
                    >
                        <button>
                            {!this.state.open && (
                                <i className="icon-plus-light"></i>
                            )}
                            {this.state.open && (
                                <i className="icon-minus-light"></i>
                            )}
                        </button>
                        <p>{this.props.title}</p>
                    </div>
                    <div className="inner-card-content">
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
    }
}
